import React from 'react';
import axios from 'axios'
import {Icon} from 'antd';
import QRCode  from 'qrcode.react';
import {
    setCookie, 
    getCookie, 
    delCookie,
    setSessionItem,
    getSessionItem,
    delSessionItem,
    isPhone,
    requestMainUrl,
    requestWeChatUrl
} from '../../common/service/common';
import { messageTips } from '../../common/service/Tools';
var setTimer;
var setSecond;
var setWechatTimer;
export default class checkLogin extends React.Component {
    state={
        phone:'',
        verifyCode:'',
        tips:'',
        tipsType:'error',
        phoneCheckStatus:false,
        hasSend:false,
        getDisabled:false,
        registerStatus:false,
        weChatCodeFlag:false,
        getSid:'',
        loginflag:true,
        userinfoFlag:false,
        registerFlag:false,
        setNameFlag:false,
        errorTips:'',
        second:5,
        setUserName:'',
        wFlag:0,
        reloadFlag:false,
        overdueFlag:false,
        openidShow:false,
    }
    
    componentDidMount() {
        var dragBtn = this.refs.dragBtn;
        var leftBorder = this.refs.invite.offsetLeft;
        dragBtn.onmousedown=(e)=>{
            if(this.state.phone==='') {
                this.setState({tips:'请输入手机号',tipsType:'error'});
                setTimeout(()=>{
                    this.setState({tips:'',tipsType:'error'});
                },2000);
                return;
            }
            if(!isPhone(this.state.phone)) {
                this.setState({tips:'请输入正确的手机号',tipsType:'error'});
                setTimeout(()=>{
                    this.setState({tips:'',tipsType:'error'});
                },2000);
                return;
            }
            var newLeft;
            document.onmousemove=(e)=>{
                newLeft = e.pageX-leftBorder-32;
                if(newLeft<0) {
                    newLeft=0;
                }
                if(newLeft>282) {
                    newLeft=282;
                }
                dragBtn.style.left=newLeft+'px';
                this.refs.draged.style.width=newLeft+'px';
            }
            document.onmouseup=()=>{
                document.onmousemove=null;
                document.onmouseup=null;
                if(newLeft<282) {
                    dragBtn.style.left=0;
                    dragBtn.style.transition='all 400ms ease 0s';
                    this.refs.draged.style.width=0;
                    this.refs.draged.style.transition='all 400ms ease 0s';
                } else {
                    this.getVerifyCode();
                }
            }
            return false;
        }
    }
    //获取验证码
    getVerifyCode=()=>{
        if(this.state.phone==='') {
            this.setState({tips:'请输入手机号',tipsType:'error'});
            setTimeout(()=>{
                this.setState({tips:'',tipsType:'error'});
            },2000);
            return;
        }
        if(!isPhone(this.state.phone)) {
            this.setState({tips:'请输入正确的手机号',tipsType:'error'});
            setTimeout(()=>{
                this.setState({tips:'',tipsType:'error'});
            },2000);
            return;
        }
        React.$http.accountVerifyGetSign({account:this.state.phone}).then(res=>{
            if(res&&res.success) {
                this.setState({phoneCheckStatus:true});
                this.refs.draged.textContent='验证通过';
                var lastSeconds = 59;
                var getCodeBtn = this.refs.getCodeBtn;
                getCodeBtn.textContent = lastSeconds+'s';
                this.setState({getDisabled:true});
                setTimer=setInterval(()=>{
                    lastSeconds-=1;
                    getCodeBtn.textContent = lastSeconds+'s';
                    if(lastSeconds<1) {
                        getCodeBtn.textContent = '获取验证码';
                        clearInterval(setTimer);
                        this.setState({getDisabled:false});
                    }
                },1000)
                React.$http.accountGetVerifyCode({account:this.state.phone,sign:res.sign}).then(res=>{
                    if(res&&res.success) {
                        this.setState({
                            // tips:res.message,tipsType:'success',
                            hasSend:true
                        });
                        if(res.verifyCode) {
                            this.setState({verifyCode:res.verifyCode});
                        }
                        setTimeout(()=>{
                            this.setState({tips:'',tipsType:'error'});
                        },2000);
                    } else {
                        if(res&&res.message) {
                            this.setState({tips:res.message,tipsType:'error'});
                        }
                        setTimeout(()=>{
                            this.setState({tips:'',tipsType:'error'});
                        },2000);
                    }
                });
            } else {
                this.setState({tips:res.message,tipsType:'error'});
                setTimeout(()=>{
                    this.setState({tips:'',tipsType:'error'});
                },2000);
            }
        });
    }

    componentWillUnmount() {
        document.onmousemove=null;
        document.onmouseup=null;
        this.setState = (state, callback) => {
            return;
        };
    }

    changePhone=(e)=>{
        this.setState({phone:e.target.value});
        var dragBtn = this.refs.dragBtn;
        dragBtn.style.left=0;
        this.refs.draged.style.width=0;

        this.refs.draged.textContent='';
        var getCodeBtn = this.refs.getCodeBtn;
        getCodeBtn.textContent = '获取验证码';
        clearInterval(setTimer);
        this.setState({hasSend:false,phoneCheckStatus:false});

    }

    changeVerifyCode=(e)=>{
        this.setState({verifyCode:e.target.value});
    }


    onSubmit=(e)=>{
        e.preventDefault();
        if(this.state.phone==='') {
            this.setState({tips:'请输入手机号',tipsType:'error'});
            setTimeout(()=>{
                this.setState({tips:'',tipsType:'error'});
            },2000);
            return false;
        }
        if(!isPhone(this.state.phone)) {
            this.setState({tips:'请输入正确的手机号',tipsType:'error'});
            setTimeout(()=>{
                this.setState({tips:'',tipsType:'error'});
            },2000);
            return false;
        }
        if(this.state.verifyCode==='') {
            this.setState({tips:'请输入验证码',tipsType:'error'});
            setTimeout(()=>{
                this.setState({tips:'',tipsType:'error'});
            },2000);
            return false;
        }
        var params = {
            account:this.state.phone,
            verifyCode:this.state.verifyCode
        }
        if(this.state.getSid){
            params.openSid = this.state.getSid;
        }
        React.$http.getPersonCheckMobileExists({
            mobile:this.state.phone
        }).then((res) => {
            if(res&&res.success){
                React.$http.goInviteLogin(params).then(res=>{
                    if(res&&res.success) {
                        setCookie('z_sid',res.sid,{time:1});
                        setCookie('userId',res.userInfo.userId,{time:1});
                        setSessionItem('userInfo',res.userInfo);
                        this.setState({tips:'登录成功！',tipsType:'success'}); 
                        var locationUrl = getCookie('loginTargetUrl');
                        setTimeout(()=>{
                            if(locationUrl) {
                                delCookie('loginTargetUrl');
                                window.location.href=locationUrl;
                            } else {
                                window.location.href='/checkpaper.html';
                            }                    
                        },500);
                    }else{
                        this.setState({tips:res&&res.message,tipsType:'error'});
                        setTimeout(()=>{
                            this.setState({tips:'',tipsType:'error'});
                        },2000);
                    }
                });
            }else{
                React.$http.accountVerifyPhoneCode(params).then(res=>{
                    if(res&&res.success) {
                        // this.setState({
                        //     userinfoFlag:true,
                        //     loginflag:false
                        // })

                        var params = {
                            account:this.state.phone,
                            verifyCode:this.state.verifyCode,
                            userName:this.state.phone,
                            openSid:getSessionItem('setSidName')?getSessionItem('setSidName'):this.state.getSid
                        }
                        React.$http.goInviteLogin(params).then(res=>{
                            if(res&&res.success) {
                                setCookie('z_sid',res.sid,{time:1});
                                setCookie('userId',res.userInfo.userId,{time:1});
                                setSessionItem('userInfo',res.userInfo);
                                this.setState({
                                    registerFlag:!this.state.registerFlag,
                                    errorTips:'',
                                    userinfoFlag:!this.state.userinfoFlag,
                                })
                                this.getSconed(5);
                                delSessionItem('setSidName');
                                delSessionItem('setNickName');
                            }else{
                                messageTips(res&&res.message,1)
                                return
                            }
                        });

                    }else{
                        this.setState({tips:res&&res.message,tipsType:'error'});
                        setTimeout(()=>{
                            this.setState({tips:'',tipsType:'error'});
                        },2000);
                        return false;
                    }
                });
            }
        });
    }
  
    getWeChatCode(e){
        e.nativeEvent.stopImmediatePropagation();
        this.setState({
            weChatCodeFlag:!this.state.weChatCodeFlag,
            loginflag:false,
            reloadFlag:false,
            overdueFlag:false,
            wFlag:0,
            phone:'',
            verifyCode:'',
        })
        clearInterval(setTimer);
        var dragBtn = this.refs.dragBtn;
        dragBtn.style.left=0;
        this.refs.draged.style.width=0;
        this.refs.draged.textContent='';
        var getCodeBtn = this.refs.getCodeBtn;
        getCodeBtn.textContent = '获取验证码';
        this.setState({hasSend:false,phoneCheckStatus:false});
        this.getLoginSid(e)
    }
    getLoginSid(e){
        clearInterval(setWechatTimer)
        e.nativeEvent.stopImmediatePropagation();
        React.$http.getWechatLoginSid().then((res) => {
            setSessionItem('setSidName',res)
            this.setState({
                getSid:res,
                overdueFlag:false,
                reloadFlag:false,
            }) 
            setWechatTimer = setInterval(() => {
                this.getEachWeChat(res)
            }, 1000);
        })
    }
    getEachWeChat(sid){
        axios({
            method: 'post',
            url: requestMainUrl + 'main/login/check/wx/'+sid+'/1',//type 1=pc端微信扫码， 2=账户设置扫码， 3=钱包扫码
        }).then(res => {
            if(res&&res.data){  
                if(res.data.status) {
                    setCookie('z_sid',res.data.sid,{time:1});
                    setCookie('userId',res.data.userInfo.userId,{time:1});
                    setSessionItem('userInfo',res.data.userInfo);
                    window.location.href='/checkpaper.html';
                    clearInterval(setWechatTimer)
                }else{
                    // 二维码过期
                    if(res.data.overdue){
                        this.setState({
                            overdueFlag:res.data.overdue
                        })
                        clearInterval(setWechatTimer)
                    }
                    // 扫描成功
                    if(res.data.phoneStatus){
                        this.setState({
                            reloadFlag:res.data.phoneStatus
                        })
                    }
                    // 点击（微信页面的）取消关闭弹窗
                    if(res.data.canCelStatus){
                        this.setState({
                            weChatCodeFlag:!this.state.weChatCodeFlag
                        })
                        clearInterval(setWechatTimer)
                        this.props.getLogin(false)
                    }
                    if(res.data.openStatus){
                        setSessionItem('setNickName',res.data.nickName)
                        this.setState({
                            wFlag:1,
                            openidShow:res.data.openId,
                            weChatCodeFlag:!this.state.weChatCodeFlag,
                            loginflag:!this.state.loginflag,
                            setUserName:getSessionItem('setNickName')?getSessionItem('setNickName'):res.data&&res.data.nickName
                        }) 
                        clearInterval(setWechatTimer)
                        return
                    }
                    return
                }
            }
        })
    }
    getLoginReturn(e){
        clearInterval(setWechatTimer)
        e.nativeEvent.stopImmediatePropagation();
        this.setState({
            loginflag:true,
            weChatCodeFlag:false,
            getSid:'',
        })
    }
    getInner=(e)=>{
        e.stopPropagation();
    }
    getLoginUser=()=>{
        var setName = this.refs.setName.value;
        if(setName===''){
            this.setState({
                errorTips:'用户名不能为空!',
            })
            setTimeout(()=>{
                this.setState({
                    errorTips:'',
                })
            },2000)
            return;
        }else if(!this.getChinese(setName)){
            this.setState({
                errorTips:'用户名格式不规范，请重新输入',
            })
            setTimeout(()=>{
                this.setState({
                    errorTips:'',
                })
            },2000)
            return;
        }else if(setName.length>15||setName.length<2){
            this.setState({
                errorTips:'用户名格式不规范，请重新输入',
            })
            setTimeout(()=>{
                this.setState({
                    errorTips:'',
                })
            },2000)
            return;
        }else{
            
            var params = {
                account:this.state.phone,
                verifyCode:this.state.verifyCode,
                userName:setName,
                openSid:getSessionItem('setSidName')?getSessionItem('setSidName'):this.state.getSid
            }
            React.$http.goInviteLogin(params).then(res=>{
                if(res&&res.success) {
                    setCookie('z_sid',res.sid,{time:1});
                    setCookie('userId',res.userInfo.userId,{time:1});
                    setSessionItem('userInfo',res.userInfo);
                    this.setState({
                        registerFlag:!this.state.registerFlag,
                        errorTips:'',
                        userinfoFlag:!this.state.userinfoFlag,
                    })
                    this.getSconed(5);
                    delSessionItem('setSidName');
                    delSessionItem('setNickName');
                }else{
                    messageTips(res&&res.message,1)
                    return
                }
            });
        }
    }
    getSconed(num){
        var lastSeconds = num;
        setSecond=setInterval(()=>{
            lastSeconds-=1;
            this.setState({
                second:lastSeconds,
            })
            if(lastSeconds<1) {
                this.getSubLoginUser()
            }
        },1000)
    }
    getChinese=(name)=>{
        var pattern = /^[a-z\d\u4e00-\u9fa5]+$/i
        if(pattern.test(name)===false){            
            return false;
        } else {
            return true;
        }
    }
    getCancelUser=()=>{
        this.props.getLogin(false)
        this.setState({
            userinfoFlag:!this.state.userinfoFlag
        })
    }
    getSubLoginUser=()=>{
        clearInterval(setSecond);
        this.props.getLogin(false)
        this.setState({
            registerFlag:!this.state.registerFlag
        })
        window.location.href='/checkpaper.html';
    }
    getDomHide(e){
        e.nativeEvent.stopImmediatePropagation();
        this.props.getLogin(false)
    }
    getReturnLogin(){
        this.setState({
            wFlag:0,
            openidShow:'',
            phone:'',
            verifyCode:'',
            getSid:'',
        })
        var dragBtn = this.refs.dragBtn;
        dragBtn.style.left=0;
        this.refs.draged.style.width=0;
        this.refs.draged.textContent='';
        var getCodeBtn = this.refs.getCodeBtn;
        getCodeBtn.textContent = '获取验证码';
        clearInterval(setTimer);
        this.setState({hasSend:false,phoneCheckStatus:false});
    }
    render() {
        const {
            phone,verifyCode,phoneCheckStatus,tips,tipsType,hasSend,getDisabled,weChatCodeFlag,getSid,loginflag,
            userinfoFlag,registerFlag,errorTips,second,setUserName,wFlag,overdueFlag,reloadFlag,openidShow
        } = this.state;
        return (
            <div className="wrapout" ref="invite" onMouseDown={(e)=>this.getDomHide(e)}>
                <div className="loginMain" style={{display:loginflag?'block':'none'}} onMouseDown={(e)=>this.getInner(e)}>
                    <div className="mlabel">
                        <span className="mlabelBank">
                            <i className="icon icon_log"></i>
                            {wFlag===0?'手机验证码登录/注册':'手机绑定'}
                        </span>
                    </div>
                    {
                        wFlag===1?(
                            <span className="wxphone" onClick={this.getReturnLogin.bind(this)}>返回验证码登录</span>
                        ):''
                    }
                    <form onSubmit={this.onSubmit}>
                        <div className="input-wrap">
                            <div className="label-name">手机号</div>
                            <div className="phone-suffix">中国大陆 +86</div>
                            <input type="text" className="input-phone" value={phone} placeholder="请输入您的手机号" onChange={this.changePhone} />
                            <span className="ico ico-success"></span>
                            <div className="clear"></div>
                        </div>
                        <div className="input-wrap drag-verify" style={{display: hasSend?'none':'block'}}>
                            <div className="label-name">验证</div>
                            <div className="bar">
                                <div className="bar-con">请按住滑块拖到最右边</div>
                                <div className="draged" ref="draged"></div>
                                <div className="drag-btn" ref="dragBtn">
                                    {
                                        phoneCheckStatus?<Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />:<span>&gt;&gt;</span>
                                    }
                                </div>
                                <div className="cover" style={{display:phoneCheckStatus?'block':'none'}}></div>
                            </div>
                            <div className="clear"></div>
                        </div>

                        <div className="input-wrap verify-input-area" style={{display: hasSend?'block':'none'}}>
                            <div className="label-name">验证码</div>
                            <input type="text" value={verifyCode} className="input-verifycode" onChange={this.changeVerifyCode} />
                            {
                                getDisabled?<button type="button" className="get-verify-btn" ref="getCodeBtn" disabled="disabled" onClick={this.getVerifyCode}>获取验证码</button>:<button type="button" className="get-verify-btn" ref="getCodeBtn" onClick={this.getVerifyCode}>获取验证码</button>
                            }
                            <div className="clear"></div>
                        </div>                    
                        <div className={tipsType}>{tips}</div>
                        <button className="login-btn">登录/注册</button>
                        <div className="login-text">未注册手机验证后自动登录，注册即代表同意<a href="/agreements.html#/user" target="_blank">《知图协议》</a></div>
                        <div className="boxlog" onClick={(e)=>this.getWeChatCode(e)}>
                            <i className="icon wechat"></i>微信
                            {
                                wFlag===1?(
                                    <span className="wxcode">微信已授权</span>
                                ):''
                            }
                        </div>
                        <span className="bshowopenid">
                            {openidShow?openidShow:''}
                        </span>
                    </form>
                </div>
                <div className="wechatInner" style={{display:weChatCodeFlag?'block':'none'}} onMouseDown={(e)=>this.getInner(e)}>
                    <div className="wechatTile">
                        <span className="labeltit">
                            <span className="label"><i className="icon icon_wx"></i>微信登录/注册</span>
                        </span>
                        <div className="labelname">
                            <span className="labname" onClick={(e)=>this.getLoginReturn(e)}>返回验证码登录</span>
                        </div>
                    </div>
                    <div className="wechatEQ">
                        <div className="qrwechat">
                            <QRCode value={requestWeChatUrl+'#/wechatlogin?sid='+getSid} size={233} fgColor="#000000" />
                            {
                                overdueFlag?(
                                    <div className="wcwchat">
                                        <div className="wctip">二维码已过期</div>
                                        <div className="wchatbtn" onClick={(e)=>this.getLoginSid(e)}>刷新二维码</div>
                                    </div>
                                ):(
                                    reloadFlag?(
                                        <div className="wechatCodoBtn">
                                            <div className="wximgtip">
                                                <i className="ico_paper iprigt"></i>
                                            </div>
                                            <div className="wcsucce">扫描成功！</div>
                                            <div className="wctup">请勿刷新页面，在手机上确认登录！</div>
                                        </div>
                                    ):''
                                )
                            }
                        </div>
                    {/* {
                        reloadFlag?(
                            <div className="wechatCodoBtn">
                                <div className="wximgtip">
                                    <i className="ico_paper iprigt"></i>
                                </div>
                                <div className="wcsucce">扫描成功！</div>
                                <div className="wctup">请勿刷新页面，在手机上确认登录！</div>
                            </div>
                        ):(
                        <div className="qrwechat">
                            <QRCode value={requestWeChatUrl+'#/wechatlogin?sid='+getSid} size={233} fgColor="#000000" />
                            {
                                overdueFlag?(
                                    <div className="wcwchat">
                                        <div className="wctip">二维码已过期</div>
                                        <div className="wchatbtn" onClick={(e)=>this.getLoginSid(e)}>刷新二维码</div>
                                    </div>
                                ):''
                            }
                        </div>
                        )
                    } */}
                    </div>
                    <div className="wefont">微信扫码，安全登录</div>
                </div>
                <div className="userInner"  style={{display:'none'}} onMouseDown={(e)=>this.getInner(e)}>
                    <span className="labeltit">
                        <span className="label"><i className="icon icon_user"></i>设置用户名</span>
                    </span>
                    <div className="nameinput">
                        <div className="names">用户名</div>
                        <div className="texts">
                            <input type="text" ref="setName" defaultValue={setUserName}/>
                            <span className="redn">*</span>
                        </div>
                        <div className="tifi">用户名规则：</div>
                        <div className="tifi">2-30个字符，支持中英文、数字，不支持特殊符号</div>
                        <div className="name_error">{errorTips}</div>
                        <div className="nbtn">
                            <span className="btn retu" onClick={this.getCancelUser}>放弃注册</span>
                            <span className="btn comt" onClick={this.getLoginUser}>确定</span>
                        </div>
                    </div>
                </div>
                <div className="regisInner" style={{display:registerFlag?'block':'none'}} onMouseDown={(e)=>this.getInner(e)}>
                    <div className="title"><i className="icon icon_succ"></i>注册成功</div>
                    <div className="content">注册成功，页面将在{second}s内自动关闭，您也可以点击下方按钮立即前往。</div>
                    <div className="regbtn">
                        <span className="btn" onClick={this.getSubLoginUser}>确定</span>
                    </div>
                </div>
            </div>
        )
    }
}